// extracted by mini-css-extract-plugin
export default {"ListOfForumsRight":"qb_a","ListOfForumsRight__brandDaysPosts":"qb_b bhi_su"};